import { render } from "./WhiteLabelForm.vue?vue&type=template&id=624ae453&scoped=true"
import script from "./WhiteLabelForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteLabelForm.vue?vue&type=script&setup=true&lang=js"

import "./WhiteLabelForm.vue?vue&type=style&index=0&id=624ae453&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624ae453"],['__file',"resources/js/modules/white-label/components/WhiteLabelForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "624ae453"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('624ae453', __exports__)) {
    api.reload('624ae453', __exports__)
  }
  
  module.hot.accept("./WhiteLabelForm.vue?vue&type=template&id=624ae453&scoped=true", () => {
    api.rerender('624ae453', render)
  })

}


export default __exports__